import "./Journal.scss";
import {useState} from "react";
import {useLocation} from "react-router-dom";
import ActionsLog from "./ActionsLog";
import SystemState from "./SystemState";
import StationSettings from "./StationSettings";
import {getPeriodRange, JournalPeriodKey, PERIODS} from "./journal.utils";

type JournalSection = "actions" | "system" | "config";

type JournalProps = {
  deviceId: string;
};

const SECTIONS: { key: JournalSection; label: string }[] = [
  {key: "actions", label: "Действия пользователей"},
  {key: "system", label: "Состояние системы"},
  {key: "config", label: "Настройки станции"},
];

// Вкладка «Журнал» (только администратор): что нажимали в приложении и что происходило с часовой системой
const Journal = ({deviceId}: JournalProps) => {
  // Со страницы «Сбои» приходят ?journal=system&period=30&filter=power
  const {search} = useLocation();
  const [initial] = useState(() => {
    const params = new URLSearchParams(search);
    const urlSection = params.get("journal");
    const urlPeriod = params.get("period");
    return {
      section: SECTIONS.find((x) => x.key === urlSection)?.key ?? "actions",
      period: PERIODS.find((x) => x.key === urlPeriod)?.key ?? "7",
      filter: params.get("filter") ?? undefined,
    };
  });
  const [section, setSection] = useState<JournalSection>(initial.section);
  const [period, setPeriod] = useState<JournalPeriodKey>(initial.period);
  // Период пересчитывается при смене кнопки или «Обновить», чтобы «сейчас» было свежим
  const [range, setRange] = useState(() => getPeriodRange(initial.period));

  const selectPeriod = (key: JournalPeriodKey) => {
    setPeriod(key);
    setRange(getPeriodRange(key));
  };

  return (
    <div className="journal">
      <div className="journal__toolbar">
        <div className="journal__sections" role="tablist">
          {SECTIONS.map((item) => (
            <button
              key={item.key}
              type="button"
              role="tab"
              aria-selected={section === item.key}
              className={`journal__section${section === item.key ? " journal__section--active" : ""}`}
              onClick={() => setSection(item.key)}
            >
              {item.label}
            </button>
          ))}
        </div>

        {section !== "config" && <div className="journal__periods">
          {PERIODS.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`journal__period${period === item.key ? " journal__period--active" : ""}`}
              onClick={() => selectPeriod(item.key)}
            >
              {item.label}
            </button>
          ))}
          <button type="button" className="journal__refresh" onClick={() => setRange(getPeriodRange(period))}>
            Обновить
          </button>
        </div>}
      </div>

      {section === "actions" && <ActionsLog deviceId={deviceId} from={range.from} to={range.to}/>}
      {section === "system" && <SystemState deviceId={deviceId} from={range.from} to={range.to} initialFilter={initial.filter}/>}
      {section === "config" && <StationSettings deviceId={deviceId}/>}
    </div>
  );
};

export default Journal;
